import {
  GetHearingQuantityListRes
} from '@gateway.Supplier'
import { yamadumiApi } from '../yamadumi-api'

export class GetSupplierHearingWorkQuantityListGateway {
  /** 業者ヒアリング(労務数)-明細取得 */
  static getHearingQuantityList = async (
    /** シミュレーション年月度 */
    simulationYm: string,
    /** 業者コード */
    supplierCd: string,
    /** 業者支店コード */
    supplierBranchCd: string,
    /** 工場コード */
    factoryCd: string,
    /** 費目コード */
    expenseCd: string,
    /** ヒアリング区分 */
    hearingKbn: string,
    /** 表示開始年度 */
    displayStartYear: string
  ) => {
    const params = {
      simulationYm,
      supplierCd,
      supplierBranchCd,
      factoryCd,
      expenseCd,
      hearingKbn,
      displayStartYear
    }
    return await yamadumiApi.get<GetHearingQuantityListRes>(
      '/api/supplier/hearing/work-quantity/list',
      params
    )
  }
}
